/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsProductVersionListItem,
    MelcoModelsProductVersionListItemFromJSON,
    MelcoModelsProductVersionListItemFromJSONTyped,
    MelcoModelsProductVersionListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsProductVersionListItem
 */
export interface MelcoModelsGenericList1MelcoModelsProductVersionListItem {
    /**
     * 
     * @type {Array<MelcoModelsProductVersionListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    list: Array<MelcoModelsProductVersionListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsProductVersionListItem {
    return MelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsProductVersionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsProductVersionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsProductVersionListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsProductVersionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsProductVersionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


